import {publishAnalyticsEventForMinorConversion} from "@khan/analytics-learning-time";
import {GuideStateApi} from "@khan/guide-state";
import {isGuideChatDisabled} from "@khan/guide-utils";

interface Args {
    pathname: string;
    newNavigationId: string;
    product?: "BROWSER_EXTENSION" | "DO_NOT_USE" | "INSTRUCTURE_CANVAS" | null;
    browserExtensionURLBeingUsedOn?: string | null;
}

/**
 * Publishes a CEDAR event for the AI Guide navigation.
 */
export function publishAiGuideNavigationEvent({
    pathname,
    newNavigationId,
    product = null,
    browserExtensionURLBeingUsedOn = null,
}: Args) {
    publishAnalyticsEventForMinorConversion({
        eventType: "AiGuideProductPageNavigated",
        eventSchemaVersion: 3,
        aiGuideNavigationId: newNavigationId,
        currentPageURL: pathname,
        isAiGuideOpen: GuideStateApi.latest().open,
        isAiGuideEnabled: !isGuideChatDisabled(pathname),
        browserExtensionURLBeingUsedOn,
        product,
    });
}
